import { useCallback, useMemo } from 'react';
import { ModalData } from '../Types';
import useGlobals from './useGlobals';
import { credentialsService } from '../Services/credentialsService';
import { setModal } from '../Store/Actions/modalActions';
import { PaginationListType } from '../Types/PaginationParams';
import { setListReloadType } from '../Store/Actions/environmentActions';
import toast from "react-hot-toast";
const useCredentials = () => {
    const { userSettings, dispatch, i18n } = useGlobals();

    const deleteCredential = useCallback(
        (identifier: string) => {
            if (!userSettings.isLoggedIn) return;
            credentialsService.deleteCredential(identifier).then((response) => {
                if(response.data.success){
                    dispatch(setListReloadType(PaginationListType.Credentials));
                } else {
                    toast.error(
                        i18n.translate({
                            id: 'credentialDelete.error',
                            sourceName: 'Credentials',
                        }),
                    );
                }
            });
        },
        [userSettings.isLoggedIn, dispatch],
    );

    const handleOpenConfirmDialog = useCallback(
        (credentialIdentifier: string) => {
            dispatch(
                setModal({
                    state: 'open',
                    title: i18n.translate({ id: 'credentialDelete.title', sourceName: 'Credentials' }),
                    content: i18n.translate({ id: 'credentialDelete.text', sourceName: 'Credentials' }),
                    modalSize: 'small',
                    closeOnAction: true,
                    showCloseButton: false,
                    buttonRightAction: () => deleteCredential(credentialIdentifier),
                } as ModalData),
            );
        },
        [dispatch, deleteCredential, i18n],
    );

    const CredentialsActions = useMemo(
        () => ({
            handleOpenConfirmDialog,
        }),
        [handleOpenConfirmDialog],
    );

    return {
        CredentialsActions,
    };
};

export default useCredentials;
